module.exports = __webpack_public_path__ + "static/img/player_head_14.381d1f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_14.jpg
// module id = Qv2N
// module chunks = 1